<template>
    <div class="plateorder">
        <div class="plateorder-tabs vue_flex vue_flex_between vue_align_center">
            <ul class="plateorder-tabs-boxs vue_flex">
                <li class="vue_relative h" :class="activeName === tabs.activeVal ? 'active' : 'activenot'"
                    v-for="(tabs, tabsIndex) in tabsList" :key="tabsIndex" @click="handleClick(tabs)">
                    <p class="vue-font-PingFang-bold">{{ tabs.title }}</p>
                    <div class="vue_absolute" v-if="activeName === tabs.activeVal"></div>
                </li>
            </ul>
            <div class="plateorder-tabs-input vue_flex vue_align_center">
                <div class="top_bar_inp vue_flex vue_align_center">
                    <img @click="getDataList" class="top_bar_inp_img1 h" src="../../../../../assets/yimou/ss.png"
                        alt="" />
                    <input type="text" class="top_bar_inp_inp" v-model="searchValue" placeholder="订单编号、SKU、商品名称关键字查询" />
                </div>

                <div class="plateorder-tabs-input-but vue-font-PingFang-500 color_255 h"
                    @click="dialogimportVisible = true">
                    导入账单
                </div>
            </div>
        </div>

        <!-- 批量删除按钮 -->
        <div class="batch-delete-container" style="margin-bottom: 15px; text-align: right;">
            <el-button type="danger" size="small" @click="batchDelete" :loading="batchDeleteLoading"
                icon="el-icon-delete" :disabled="selectedRows.length === 0">
                批量删除 (已选{{ selectedRows.length }}条)
            </el-button>
        </div>

        <div class="width_100" v-if="activeName === 'taobao'">
            <el-table :data="dataList" style="width: 100%" :header-cell-style="headercellstyle" border height="70vh"
                :key="'taobaoTable'" ref="orderTable" @selection-change="handleSelectionChange">
                <!-- 批量选择列 -->
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="ordertype" label="订单类型" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.ordertype === '' ? '普通单' : '特殊单' }}
                    </template>
                </el-table-column>
                <el-table-column prop="order_id" label="子订单编号" align="center"></el-table-column>
                <el-table-column prop="master_order_id" label="主订单编号" align="center"></el-table-column>
                <el-table-column prop="goodsname" label="商品标题" align="center"></el-table-column>
                <el-table-column prop="goodsid" label="商品ID" align="center"></el-table-column>
                <el-table-column prop="skuid" label="SKU" align="center"></el-table-column>
                <el-table-column prop="goodsprice" label="商品售价" align="center"></el-table-column>
                <el-table-column prop="goodsattribute" label="商品属性" align="center"></el-table-column>
                <el-table-column prop="buynum" label="购买数量" align="center"></el-table-column>
                <el-table-column prop="" label="套餐信息" align="center"></el-table-column>
                <el-table-column prop="" label="联系方式备注" align="center"></el-table-column>
                <el-table-column prop="status" label="订单状态" align="center"></el-table-column>
                <el-table-column prop="shopid" label="商家编码" align="center"></el-table-column>
                <el-table-column prop="payorderid" label="支付单号" align="center"></el-table-column>
                <el-table-column prop="yingfukuan" label="买家应付款" align="center"></el-table-column>
                <el-table-column prop="shifukuan" label="买家实付款" align="center"></el-table-column>
                <el-table-column prop="tuikuanstatus" label="退款状态" align="center"></el-table-column>
                <el-table-column prop="tuikuanmoney" label="退款金额" align="center"></el-table-column>
                <el-table-column prop="createtime" label="订单创建时间" align="center"></el-table-column>
                <el-table-column prop="paytime" label="订单付款时间" align="center"></el-table-column>
                <el-table-column prop="type" label="海鲜达渠道" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.type === '1' ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column prop="fahuotime" label="发货时间" align="center"></el-table-column>
                <el-table-column prop="" label="主动赔付金额" align="center"></el-table-column>
                <el-table-column prop="" label="分阶段信息" align="center"></el-table-column>
                <el-table-column prop="" label="备注标签" align="center"></el-table-column>
                <el-table-column prop="" label="商家备注" align="center"></el-table-column>
                <el-table-column prop="" label="主订单买家留言" align="center"></el-table-column>
                <el-table-column prop="" label="物流单号" align="center"></el-table-column>
                <el-table-column prop="" label="物流公司" align="center"></el-table-column>
                <el-table-column prop="" label="是否主动赔付" align="center"></el-table-column>
                <el-table-column prop="" label="主动赔付金额" align="center"></el-table-column>
                <el-table-column prop="" label="主动赔付出账时间" align="center"></el-table-column>
                <el-table-column prop="yingfahuotime" label="应发货时间" align="center"></el-table-column>
                <el-table-column prop="" label="飞猪购订单信息" align="center"></el-table-column>
                <el-table-column prop="" label="免单资格" align="center"></el-table-column>
                <el-table-column prop="" label="免单金额" align="center"></el-table-column>
                <el-table-column prop="" label="百亿补贴超链订单信息" align="center"></el-table-column>

                <el-table-column align="center" label="操作" width="160" class-name="small-padding fixed-width">
                    <template slot-scope="row">
                        <el-button type="danger" size="small" @click="handleDelete(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="width_100" v-if="activeName === 'jingdong'">
            <el-table :data="dataList" style="width: 100%" :header-cell-style="headercellstyle" border height="70vh"
                :key="'jingdongTable'" ref="orderTable" @selection-change="handleSelectionChange">
                <!-- 批量选择列 -->
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="ordertype" label="订单类型" align="center"></el-table-column>
                <el-table-column prop="order_id" label="订单号" align="center"></el-table-column>
                <el-table-column prop="goodsid" label="商品ID" align="center"></el-table-column>
                <el-table-column prop="skuid" label="SKU" align="center"></el-table-column>
                <el-table-column prop="goodsname" label="商品名称" align="center"></el-table-column>
                <el-table-column prop="" label="支付方式" align="center"></el-table-column>
                <el-table-column prop="paytime" label="下单时间" align="center"></el-table-column>
                <el-table-column prop="" label="京东价" align="center"></el-table-column>
                <el-table-column prop="shifukuan" label="订单金额" align="center"></el-table-column>
                <el-table-column prop="" label="结算金额" align="center"></el-table-column>
                <el-table-column prop="" label="余额支付" align="center"></el-table-column>
                <el-table-column prop="yingfukuan" label="应付金额" align="center"></el-table-column>
                <el-table-column prop="status" label="订单状态" align="center"></el-table-column>
                <el-table-column prop="" label="订单标签" align="center"></el-table-column>
                <el-table-column prop="" label="下单账号" align="center"></el-table-column>
                <el-table-column prop="" label="订单备注" align="center"></el-table-column>
                <el-table-column prop="" label="发票类型" align="center"></el-table-column>
                <el-table-column prop="" label="发票抬头" align="center"></el-table-column>
                <el-table-column prop="" label="发票内容" align="center"></el-table-column>
                <el-table-column prop="" label="纳税人识别号" align="center"></el-table-column>
                <el-table-column prop="" label="名称（个人）" align="center"></el-table-column>
                <el-table-column prop="" label="单位地址" align="center"></el-table-column>
                <el-table-column prop="" label="单位电话" align="center"></el-table-column>
                <el-table-column prop="" label="开户银行" align="center"></el-table-column>
                <el-table-column prop="" label="银行账号" align="center"></el-table-column>
                <el-table-column prop="" label="商家备注" align="center"></el-table-column>
                <el-table-column prop="" label="商家备注等级" align="center"></el-table-column>
                <el-table-column prop="" label="运费金额" align="center"></el-table-column>
                <el-table-column prop="" label="付款确认时间" align="center"></el-table-column>
                <el-table-column prop="" label="货号" align="center"></el-table-column>
                <el-table-column prop="" label="订单完成时间" align="center"></el-table-column>
                <el-table-column prop="" label="订单来源" align="center"></el-table-column>
                <el-table-column prop="" label="订单渠道" align="center"></el-table-column>
                <el-table-column prop="" label="送装服务" align="center"></el-table-column>
                <el-table-column prop="" label="服务费" align="center"></el-table-column>
                <el-table-column prop="" label="仓库id" align="center"></el-table-column>
                <el-table-column prop="" label="仓库名称" align="center"></el-table-column>
                <el-table-column prop="" label="邮箱地址" align="center"></el-table-column>
                <el-table-column prop="" label="邮政编码" align="center"></el-table-column>
                <el-table-column prop="" label="是否为toplife订单" align="center"></el-table-column>
                <el-table-column prop="" label="业务类型" align="center"></el-table-column>
                <el-table-column prop="" label="履约门店ID" align="center"></el-table-column>
                <el-table-column prop="" label="下单门店ID" align="center"></el-table-column>
                <el-table-column prop="" label="门店名称" align="center"></el-table-column>
                <el-table-column prop="" label="门店联系人" align="center"></el-table-column>
                <el-table-column prop="" label="门店联系电话" align="center"></el-table-column>

                <el-table-column prop="" label="门店地址" align="center"></el-table-column>
                <el-table-column prop="" label="导购员账号" align="center"></el-table-column>
                <el-table-column prop="" label="延迟报备类型" align="center"></el-table-column>
                <el-table-column prop="" label="订单出库时间" align="center"></el-table-column>
                <el-table-column prop="" label="客户类型" align="center"></el-table-column>
                <el-table-column prop="" label="KA订单发货需提供单据" align="center"></el-table-column>
                <el-table-column prop="" label="KA订单客户收货要求" align="center"></el-table-column>
                <el-table-column prop="" label="正品鉴定校验结果" align="center"></el-table-column>
                <el-table-column prop="" label="正品鉴定补充说明" align="center"></el-table-column>
                <el-table-column prop="" label="正品鉴定不合格原因" align="center"></el-table-column>
                <el-table-column prop="" label="正品鉴定图片链接" align="center"></el-table-column>
                <el-table-column prop="" label="企配订单" align="center"></el-table-column>
                <el-table-column prop="" label="需上传SN码" align="center"></el-table-column>
                <el-table-column prop="" label="SN码" align="center"></el-table-column>
                <el-table-column prop="" label="SN码有效状态" align="center"></el-table-column>
                <el-table-column prop="" label="SN码激活状态" align="center"></el-table-column>
                <el-table-column prop="" label="SN码补贴状态" align="center"></el-table-column>
                <el-table-column prop="" label="百补满赠" align="center"></el-table-column>
                <el-table-column prop="" label="买一试三" align="center"></el-table-column>
                <el-table-column prop="yingfahuotime" label="承诺发货时间" align="center"></el-table-column>
                <el-table-column prop="" label="款项名称" align="center"></el-table-column>
                <el-table-column prop="" label="项目ID" align="center"></el-table-column>
                <el-table-column prop="" label="指数订单编号" align="center"></el-table-column>
                <el-table-column prop="" label="是否为以旧换新订单" align="center"></el-table-column>
                <el-table-column prop="" label="主体ID" align="center"></el-table-column>
                <el-table-column prop="" label="主体名称" align="center"></el-table-column>
                <el-table-column align="center" label="操作" width="160" class-name="small-padding fixed-width">
                    <template slot-scope="row">
                        <el-button type="danger" size="small" @click="handleDelete(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="width_100" v-if="activeName === 'pduoduo'">
            <el-table :data="dataList" style="width: 100%" :header-cell-style="headercellstyle" border height="70vh"
                :key="'pduoduoTable'" ref="orderTable" @selection-change="handleSelectionChange">
                <!-- 批量选择列 -->
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="ordertype" label="订单类型" align="center"></el-table-column>
                <el-table-column prop="order_id" label="订单号" align="center"></el-table-column>
                <el-table-column prop="goodsname" label="商品名称" align="center"></el-table-column>
                <el-table-column prop="status" label="订单状态" align="center"></el-table-column>
                <el-table-column prop="buynum" label="商品数量(件)" align="center"></el-table-column>
                <el-table-column prop="" label="是否审核中" align="center"></el-table-column>
                <el-table-column prop="paytime" label="支付时间" align="center"></el-table-column>
                <el-table-column prop="yingfahuotime" label="承诺发货时间" align="center"></el-table-column>
                <el-table-column prop="" label="承诺送达时间" align="center"></el-table-column>
                <el-table-column prop="fahuotime" label="发货时间" align="center"></el-table-column>
                <el-table-column prop="" label="确认收货时间" align="center"></el-table-column>
                <el-table-column prop="goodsid" label="商品id" align="center"></el-table-column>
                <el-table-column prop="goodsattribute" label="商品规格" align="center"></el-table-column>
                <el-table-column prop="" label="样式ID" align="center"></el-table-column>
                <el-table-column prop="" label="商品一级类目" align="center"></el-table-column>
                <el-table-column prop="" label="商品二级类目" align="center"></el-table-column>
                <el-table-column prop="" label="商品三级类目" align="center"></el-table-column>
                <el-table-column prop="" label="商品四级类目" align="center"></el-table-column>
                <el-table-column prop="" label="商家编码-商品维度" align="center"></el-table-column>
                <el-table-column prop="" label="商家备注" align="center"></el-table-column>
                <el-table-column prop="" label="买家留言" align="center"></el-table-column>
                <el-table-column prop="" label="售后状态" align="center"></el-table-column>
                <el-table-column prop="" label="消费者资料" align="center"></el-table-column>
                <el-table-column prop="createtime" label="订单成交时间" align="center"></el-table-column>
                <el-table-column prop="" label="消费者资料上传时间" align="center"></el-table-column>
                <el-table-column prop="" label="赠品名称" align="center"></el-table-column>
                <el-table-column prop="" label="赠品ID" align="center"></el-table-column>
                <el-table-column prop="" label="赠品规格" align="center"></el-table-column>
                <el-table-column prop="" label="赠品数量" align="center"></el-table-column>
                <el-table-column prop="" label="团ID" align="center"></el-table-column>
                <el-table-column prop="" label="团身份" align="center"></el-table-column>
                <el-table-column prop="" label="是否已开始配送" align="center"></el-table-column>
                <el-table-column prop="" label="配送员是否已送达" align="center"></el-table-column>
                <el-table-column prop="" label="配送状态" align="center"></el-table-column>
                <el-table-column prop="" label="同城是否普通快递" align="center"></el-table-column>
                <el-table-column label="商品总价（元）" align="center">
                    <template slot-scope="scope">
                        <span>{{ (Number(scope.row.goodsprice) * Number(scope.row.buynum)).toFixed(2) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="yunfei" label="邮费（元）" align="center"></el-table-column>
                <el-table-column prop="" label="店铺优惠折扣（元）" align="center"></el-table-column>
                <el-table-column prop="" label="平台优惠折扣（元）" align="center"></el-table-column>
                <el-table-column prop="" label="多多支付立减金额（元）" align="center"></el-table-column>
                <el-table-column prop="" label="上门安装费（元）" align="center"></el-table-column>
                <el-table-column prop="" label="送货入户费（元）" align="center"></el-table-column>
                <el-table-column prop="" label="送货入户并安装费（元）" align="center"></el-table-column>
                <el-table-column prop="shifukuan" label="用户实付金额（元）" align="center"></el-table-column>
                <el-table-column prop="shoukuan" label="商家实收金额（元）" align="center"></el-table-column>
                <el-table-column prop="" label="快递单号" align="center"></el-table-column>
                <el-table-column prop="" label="快递公司" align="center"></el-table-column>
                <el-table-column prop="" label="省" align="center"></el-table-column>
                <el-table-column prop="" label="市" align="center"></el-table-column>
                <el-table-column prop="" label="区" align="center"></el-table-column>
                <el-table-column prop="" label="街道/镇" align="center"></el-table-column>
                <el-table-column prop="" label="配送员手机号" align="center"></el-table-column>
                <el-table-column prop="" label="是否抽奖或0元试用" align="center"></el-table-column>
                <el-table-column prop="" label="是否顺丰加价" align="center"></el-table-column>
                <el-table-column prop="" label="用户购买手机号" align="center"></el-table-column>
                <el-table-column prop="" label="旅行类信息" align="center"></el-table-column>
                <el-table-column prop="" label="充值号码" align="center"></el-table-column>
                <el-table-column prop="" label="是否门店自提" align="center"></el-table-column>
                <el-table-column prop="" label="门店名称" align="center"></el-table-column>
                <el-table-column prop="" label="门店自定义编码" align="center"></el-table-column>
                <el-table-column prop="" label="关联货品编码" align="center"></el-table-column>
                <el-table-column prop="" label="货品名称" align="center"></el-table-column>
                <el-table-column prop="" label="货品类型" align="center"></el-table-column>
                <el-table-column prop="" label="子货品" align="center"></el-table-column>
                <el-table-column prop="" label="仓库名称" align="center"></el-table-column>
                <el-table-column prop="" label="仓库所在地址" align="center"></el-table-column>
                <el-table-column prop="" label="淘淘清关订单号" align="center"></el-table-column>
                <el-table-column prop="payorderid" label="支付ID" align="center"></el-table-column>
                <el-table-column prop="" label="支付方式" align="center"></el-table-column>
                <el-table-column prop="" label="报税仓" align="center"></el-table-column>
                <el-table-column prop="" label="是否直播间成交" align="center"></el-table-column>
                <el-table-column prop="" label="是否直播间引导成交" align="center"></el-table-column>
                <el-table-column prop="" label="预约配送时间" align="center"></el-table-column>
                <el-table-column prop="" label="是否节能补贴" align="center"></el-table-column>
                <el-table-column prop="" label="是否分期" align="center"></el-table-column>
                <el-table-column prop="" label="分期期数" align="center"></el-table-column>
                <el-table-column prop="" label="手续费承担方" align="center"></el-table-column>
                <el-table-column prop="" label="是否无痕发货" align="center"></el-table-column>
                <el-table-column prop="" label="订单来源" align="center"></el-table-column>
                <el-table-column prop="" label="是否社区团购" align="center"></el-table-column>
                <el-table-column prop="" label="小区送达情况" align="center"></el-table-column>
                <el-table-column prop="" label="分期方式" align="center"></el-table-column>
                <el-table-column align="center" label="操作" width="160" class-name="small-padding fixed-width">
                    <template slot-scope="row">
                        <el-button type="danger" size="small" @click="handleDelete(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
            @pagination="getDataList" />

        <el-dialog :visible.sync="dialogimportVisible" custom-class="unique-dialog" width="752px"
            :close-on-click-modal="false" :show-close="false">
            <div class="import-mask vue_flex vue_align_center vue_column">
                <div class="import-mask-title vue-font-PingFang-500 color_255 vue_relative">
                    导入订单
                    <img src="../../../../../assets/yimou/gb.png" alt="" class="vue_absolute h" @click="
                        (dialogimportVisible = false),
                        (fileName = ''),
                        (alifileName = ''),
                        (tempObj.channelVal = '')
                        " />
                </div>
                <div class="import-mask-boxs vue_flex vue_column">
                    <div class="import-mask-boxs-inp">
                        <ul class="vue_flex vue_align_center">
                            <li class="vue_flex vue-font-PingFang-500">
                                <span>*</span>
                                <p class="color_35">渠道</p>
                            </li>
                            <li class="import-mask-ul-boxs">
                                <el-select v-model="tempObj.channelVal" placeholder="请选择">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </li>
                        </ul>
                    </div>
                    <div class="import-mask-boxs-inp">
                        <ul class="vue_flex vue_align_center">
                            <li class="vue_flex vue-font-PingFang-500">
                                <span>*</span>
                                <p class="color_35">订单类型</p>
                            </li>
                            <li class="import-mask-ul-boxs">
                                <el-select v-model="typeValue" placeholder="请选择">
                                    <el-option label="普通单" value="0"></el-option>
                                    <el-option label="特殊单" value="1"></el-option>
                                </el-select>
                            </li>
                        </ul>
                    </div>
                    <div class="import-mask-boxs-inp">
                        <ul class="vue_flex vue_align_center">
                            <li class="vue_flex vue-font-PingFang-500">
                                <span>*</span>
                                <p class="color_35">店铺</p>
                            </li>
                            <li class="import-mask-ul-boxs">
                                <el-select v-model="tempObj.shopid" placeholder="请选择">
                                    <el-option v-for="item in dpList" :key="item.id" :label="item.name"
                                        :value="item.id"></el-option>
                                </el-select>
                            </li>
                        </ul>
                    </div>

                    <div class="import-mask-boxs-img vue_flex vue_column">
                        <img src="../../../../../assets/yimou/dyb.png" alt="" />
                        <div class="import-mask-boxs-img-view vue_flex vue_align_center vue_flex_between h">
                            <p class="vue-font-PingFang-500 color_35">导入模版</p>
                            <div class="vue-font-PingFang-500 color_255" @click="downloadModel()">
                                下载
                            </div>
                        </div>
                    </div>

                    <div class="import-mask-boxs-upload size_no_repeat vue_flex vue_column vue_align_center">
                        <el-upload class="upload-demo" :http-request="leading" drag action multiple action="/"
                            ref="limit" :show-file-list="false">
                            <div v-if="alifileName == ''">
                                <img src="../../../../../assets/yimou/cwj.png" alt="" />
                                <p class="upload-title vue-font-PingFang-500">
                                    <span>点击上传</span>
                                </p>
                                <p class="upload-content vue-font-PingFang-500 color_94">
                                    只能上传 excel 文件
                                </p>
                            </div>
                            <div v-else>
                                <img src="../../../../../assets/ym/excel.png" alt="" class="file-icon" />
                                <div style="margin-top: 30px">{{ fileName }}</div>
                            </div>
                        </el-upload>
                    </div>
                </div>
                <div class="import-mask-but vue-font-PingFang-500 color_255 h" @click="toApply">
                    确认
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { windowFun } from "@/utils/utils";
import DonMessage from "@/utils/message";
import Cookies from "js-cookie";
import axios from "axios";
import { uploadimgtooss } from "@/utils/uploadoss.js";
export default {
    components: { Pagination },
    data() {
        return {
            innerWidth: 0,
            innerHeight: 0,
            headercellstyle: {
                backgroundColor: "rgba(245, 247, 250, 1)",
                color: "rgba(51, 3, 0, 1)",
            },

            total: 0,
            listQuery: {
                page: 1,
                limit: 10,
                shopid: "",
                type: "",
            },

            dialogimportVisible: false,

            activeName: "taobao",
            tabsList: [
                { title: "天猫淘宝", activeVal: "taobao" },
                { title: "京东", activeVal: "jingdong" },
                { title: "拼多多", activeVal: "pduoduo" },
            ],
            fileName: "",
            alifileName: "",

            searchValue: "",
            dataList: [],
            taobaoList: [],
            jingdongList: [],
            pduoduoList: [],

            options: [
                { value: "1", label: "淘宝" },
                { value: "2", label: "京东" },
                { value: "3", label: "拼多多" },
            ],

            typeValue: '0',
            tempObj: {
                channelVal: "",
                typeVal: "",
                shopid: "",
            },
            dpList: [],
            fileObj: null,
            // 批量删除相关数据
            selectedRows: [],
            batchDeleteLoading: false,
        };
    },

    created() {
        this.innerWidth = windowFun().innerWidth;
        this.innerHeight = windowFun().innerHeight;
        this.getDataList();
        this.getdpListFun();
    },

    methods: {
        // 处理表格选中行变化
        handleSelectionChange(val) {
            this.selectedRows = val;
        },

        // 批量删除方法
        async batchDelete() {
            // 1. 校验选中数据
            if (this.selectedRows.length === 0) {
                return DonMessage.warning("请先选择需要删除的订单");
            }

            // 2. 二次确认
            try {
                await this.$confirm(
                    `您确定要删除选中的 ${this.selectedRows.length} 条订单吗？`,
                    "警告！",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }
                );

                // 3. 开始批量删除
                this.batchDeleteLoading = true;
                let successCount = 0;
                let failCount = 0;

                // 4. 循环调用删除接口
                for (const row of this.selectedRows) {
                    try {
                        const res = await this.$http.get(this.$urls.delOrder, {
                            order_id: row.order_id,
                        });
                        if (res.errcode === 0) {
                            successCount++;
                        } else {
                            failCount++;
                            console.error(`删除订单 ${row.order_id} 失败：`, res.errmsg);
                        }
                    } catch (err) {
                        failCount++;
                        console.error(`删除订单 ${row.order_id} 异常：`, err);
                    }
                }

                // 5. 结果提示
                if (failCount === 0) {
                    DonMessage.success(`批量删除成功！共删除 ${successCount} 条订单`);
                } else if (successCount === 0) {
                    DonMessage.error(`批量删除失败！${failCount} 条订单删除失败`);
                } else {
                    DonMessage.warning(`批量删除完成！成功 ${successCount} 条，失败 ${failCount} 条`);
                }

                // 6. 刷新列表 + 清空选中状态（替换可选链为兼容写法）
                this.getDataList();
                if (this.$refs.orderTable) {
                    this.$refs.orderTable.clearSelection();
                }
                this.selectedRows = [];
            } catch (err) {
                // 取消删除
                DonMessage.info("已取消批量删除");
            } finally {
                // 关闭加载状态
                this.batchDeleteLoading = false;
            }
        },

        // 删除（原有方法）
        handleDelete(row) {
            this.$confirm("您确定删除么?", "警告！", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                const res = await this.$http.get(this.$urls.delOrder, { order_id: row.row.order_id });
                console.log("----", res);
                if (res.errcode == 0) {
                    DonMessage.success("删除成功");
                    this.getDataList();
                } else {
                    DonMessage.error("删除失败");
                }
            })
                .catch((err) => {
                    console.log(err);
                });
        },

        downloadModel() {
            let url = "";

            if (this.activeName === "taobao")
                url =
                    "https://img.yimoubi.com/1-static-moban/%E5%A4%A9%E7%8C%AB%E6%B7%98%E5%AE%9D%E5%B9%B3%E5%8F%B0%E8%AE%A2%E5%8D%95%E6%A8%A1%E6%9D%BF%E8%A1%A8.xlsx";
            if (this.activeName === "jingdong")
                url =
                    "https://img.yimoubi.com/1-static-moban/%E4%BA%AC%E4%B8%9C%E5%B9%B3%E5%8F%B0%E8%AE%A2%E5%8D%95%E6%A8%A1%E6%9D%BF%E8%A1%A8.xlsx";
            if (this.activeName === "pduoduo")
                url =
                    "https://img.yimoubi.com/1-static-moban/%E6%8B%BC%E5%A4%9A%E5%A4%9A%E5%B9%B3%E5%8F%B0%E8%AE%A2%E5%8D%95%E6%A8%A1%E6%9D%BF%E8%A1%A8.xlsx";

            const link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", "模板.xlsx");
            document.body.appendChild(link);
            link.click();
        },
        async toApply() {
            if (!this.tempObj.channelVal) return DonMessage.error(`请选择渠道`);
            if (!this.tempObj.shopid) return DonMessage.error(`请选择店铺`);
            console.log('this.tempObj--->', this.tempObj);
            if (!this.alifileName) return DonMessage.error(`请上传文件`);
            let params = {
                type: this.tempObj.channelVal,
                shopid: this.tempObj.shopid,
                file_path: this.alifileName,
            };

            let res = null
            if (this.typeValue === '0') {
                res = await this.$http.post(this.$urls.importorders, params);
            }
            if (this.typeValue === '1') {
                res = await this.$http.post(this.$urls.setspecialorders, params);
            }
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.dialogimportVisible = false;
            this.tempObj.channelVal = "";
            this.tempObj.shopid = "";
            this.alifileName = "";
            this.fileName = "";
            this.getDataList();
        },
        handleImgSuccess(file) {
            this.fileName = file.name;
            uploadimgtooss(file).then((res) => {
                this.alifileName = res;
            });
        },
        async leading(param) {
            this.listLoading = true;
            let fileObj = param.file;
            let uploadForm = new FormData();
            uploadForm.append("file", fileObj);

            const res = await this.$http.postfile(this.$urls.uploadFile, uploadForm);
            console.log("----", res);
            this.fileName = param.file.name;
            this.alifileName = res.data.file_path;
        },
        // 店铺列表
        async getdpListFun() {
            const res = await this.$http.get(this.$urls.getshoplist, {
                page: 1,
                limit: 10000,
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.dpList = res.list;
        },
        async getDataList() {
            let ty = "";
            if (this.activeName === "taobao") ty = "1";
            if (this.activeName === "jingdong") ty = "2";
            if (this.activeName === "pduoduo") ty = "3";

            let params = {
                page: this.listQuery.page,
                limit: this.listQuery.limit,
                type: ty,
                searchText: this.searchValue,
                shopid: this.listQuery.shopid,
            };
            console.log("params---", params);

            const res = await this.$http.get(this.$urls.getorderlist, params);
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            console.log("111", res);
            this.dataList = res.list;
            this.total = res.count;
        },
        handleClick(row) {
            if (this.activeName === row.activeVal) return;
            this.activeName = row.activeVal;
            // 切换标签时清空选中状态（替换可选链为兼容写法）
            if (this.$refs.orderTable) {
                this.$refs.orderTable.clearSelection();
            }
            this.selectedRows = [];
            this.getDataList();
        },

        activeFun() {
            this.dataList = [];
            if (this.activeName === "taobao") {
                this.dataList = JSON.parse(JSON.stringify(this.taobaoList));
            }
            if (this.activeName === "jingdong") {
                this.dataList = JSON.parse(JSON.stringify(this.jingdongList));
            }
            if (this.activeName === "pduoduo") {
                this.dataList = JSON.parse(JSON.stringify(this.pduoduoList));
            }
        },

        getHetongListFun() { },
    },
};
</script>

<style lang="scss" scoped>
.import-mask-boxs-img {
    margin-bottom: 21px;
    margin-top: 40px;

    img {
        width: 118px;
        height: auto;
    }

    .import-mask-boxs-img-view {
        width: fit-content;
        padding: 0px 14px 0px 17px;
        height: 68px;
        background: #f5f5f5;
        margin-top: 17px;
        border-radius: 10px;

        p {
            font-size: 18px;
            line-height: 18px;
        }

        div {
            width: 90px;
            height: 37px;
            margin-left: 48px;
            line-height: 37px;
            text-align: center;
            font-size: 14px;
            background: #195cf8;
            border-radius: 5px;
        }
    }

    .import-mask-boxs-img-text {
        font-size: 14px;
        line-height: 14px;
        margin-top: 11px;
    }
}

.plateorder {
    padding: 22px;
}

.file-icon {
    width: 150px;
    height: 200px;
}

.plateorder-tabs {
    background: rgba(245, 245, 245, 1);
    border-radius: 10px;
    padding: 9px 18px 8px 47px;
    margin-bottom: 28px;

    .plateorder-tabs-boxs {
        gap: 68px;

        li {
            p {
                font-size: 26px;
            }

            div {
                width: 100%;
                height: 3px;
                background: rgba(25, 92, 248, 1);
                border-radius: 2px;
                bottom: -12px;
                left: 0px;
            }
        }

        .active {
            color: rgba(25, 92, 248, 1);
        }

        .activenot {
            color: rgba(35, 35, 35, 1);
        }
    }

    .plateorder-tabs-input {
        .top_bar_inp {
            width: 372px;
            height: 54px;
            background: rgba(255, 255, 255, 1);
            border-radius: 10px;
            margin-right: 32px;
            padding: 0 11px;

            .top_bar_inp_img1 {
                width: 24px;
                height: 24px;
                margin-right: 12px;
            }

            .top_bar_inp_inp {
                width: 282px;
            }
        }

        .plateorder-tabs-input-but {
            width: 131px;
            height: 54px;
            background: rgba(25, 92, 248, 1);
            border-radius: 10px;
            font-size: 20px;
            line-height: 54px;
            text-align: center;
        }
    }
}

.import-mask {
    width: 100%;
    border-radius: 15px;
    background-image: url("../../../../../assets/yimou/tb.png");
    background-size: 100% 51px;
    background-repeat: no-repeat;
    padding-bottom: 40px;

    .import-mask-title {
        width: 100%;
        height: 51px;
        line-height: 51px;
        text-align: center;
        font-size: 18px;

        img {
            width: 13px;
            height: 13px;
            top: 21px;
            right: 20px;
        }
    }

    .import-mask-boxs {
        width: 650px;
        margin-top: 34px;

        .import-mask-boxs-inp {
            width: 100%;
            background: rgba(245, 245, 245, 1);
            border-radius: 10px;
            padding: 11px 22px;
            margin-bottom: 19px;

            ul {
                li:nth-of-type(1) {
                    width: 145px;
                    font-size: 18px;
                    line-height: 18px;

                    span {
                        color: rgba(255, 0, 0, 1);
                    }
                }
            }
        }

        .import-mask-boxs-upload {
            width: 100%;
            height: 168px;
            margin: 10px 0px 34px;
            background-image: url("../../../../../assets/yimou/hsk.png");

            img {
                width: 35px;
                height: 31px;
                margin-top: 39px;
            }

            .upload-title {
                font-size: 16px;
                line-height: 16px;
                margin: 16px 0px 13px;

                span:nth-of-type(2) {
                    color: rgba(20, 75, 201, 1);
                }
            }

            .upload-content {
                font-size: 14px;
                line-height: 14px;
            }
        }

        .import-mask-ul-boxs {
            width: 24vw;
        }
    }

    .import-mask-but {
        width: 266px;
        height: 47px;
        line-height: 47px;
        text-align: center;
        background: rgba(25, 92, 248, 1);
        border-radius: 10px;
        font-size: 17px;
    }
}

.import-mask-boxs-inp .el-input /deep/.el-input__inner {
    border: none !important;
    font-size: 18px;
}

.revenbook-drawer .el-input /deep/.el-input__inner {
    border: none !important;
    background: none !important;
    font-size: 18px;
}

.el-select {
    width: 100% !important;
}

.el-select /deep/.el-input__inner {
    width: 100%;
    border: none !important;
    background: none !important;
    font-size: 18px;
}

.el-select /deep/.el-select__caret {
    color: #000000 !important;
}

.upload-demo /deep/.el-upload-dragger {
    background: none !important;
    border: none !important;
    border-radius: 0px !important;
    width: 640px !important;
    height: 168px;
}

/* 批量删除按钮样式优化 */
.batch-delete-container {
    .el-button {
        padding: 8px 15px;
        font-size: 14px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/level1/data_center/plateorder/index.vue